import { SelfServeContext } from "../../types";

import { brandIsRejected } from "./businessRules/brandIsRejected";

export const accountVerificationRejectedVisibilityFn = (
  _context: SelfServeContext
) => {
  return Promise.resolve(brandIsRejected());
};
